// extracted by mini-css-extract-plugin
module.exports = {"badge":"FavoritesBadge_badge__eoFPq"};